<script>
import {
  alertMethods,
  authComputed,
  organizationComputed,
} from '@state/helpers';

export default {
  data() {
    return {
      showBanner: Notification.permission === 'default',
    };
  },
  computed: {
    ...authComputed,
    ...organizationComputed,
    show() {
      return this.loggedIn && this.showBanner;
    },
  },
  created() {
    this.setShowAlertBanner(this.showBanner);
  },
  methods: {
    ...alertMethods,
    handlePermission(permission) {
      const showBanner = permission === 'default';
      this.showBanner = showBanner;
      this.setShowAlertBanner(showBanner);
    },
    checkNotificationPromise() {
      // Is promise based supported?
      try {
        Notification.requestPermission().then();
      } catch (e) {
        return false;
      }

      return true;
    },
    async grantPermission() {
      if (Notification.permission === 'default') {
        // if promise based not supported, use callback (case for safari)
        if (this.checkNotificationPromise()) {
          const permission = await Notification.requestPermission();
          this.handlePermission(permission);
        } else {
          Notification.requestPermission((permission) => {
            this.handlePermission(permission);
          });
        }
      }
    },
  },
};
</script>

<template>
  <div class="notification-banner-alert" v-if="show">
    <p>
      {{ organizationTitle }} needs your permission to
      <button @click.stop="grantPermission">
        enable desktop notification
      </button>
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.notification-banner-alert {
  background-color: $color-primary-four;
  color: white;
  margin-bottom: 0;
  padding: 15px;
  text-align: center;

  p {
    margin: 0;
  }

  button {
    background-color: transparent;
    border: none;
    color: inherit;
    cursor: pointer;
    font-size: inherit;
    margin: 0;
    padding: 0;
    text-decoration: underline;
  }
}
</style>
